import { useHasPermission } from "../../auth/useClaims";

// Branch-wise master (handoff §9.8/§13.3) - Products.Create/.Edit are
// separate permissions a role can hold independently, same pattern as
// Customers; no all-branch check needed, the API already scopes every
// request to the caller's own branch(es) server-side. Product Groups are a
// sub-resource of Products (own CRUD routes, but no separate permission
// codes in the catalog) so their writes are gated the same way: Create for
// adding a new group, Edit for update/delete.
export const useCanCreateProducts = () => useHasPermission("Products.Create");
export const useCanEditProducts = () => useHasPermission("Products.Edit");
